import React, { Component } from 'react';
import { Button, Icon, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL, WEB_URL } from '../App.js';
import '../App.css';
import { TagColors } from './SearchHelper.js';
import {nounoptions1, nounoptions2, options1, options2, options3, customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam} from './constants/constants.js'
import * as Scroll from 'react-scroll';
import ReactGA from "react-ga4";
ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;
// let customFontFam = "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

let innerWidthSetting = 480

class Entry extends Component {
	constructor(props) {
		super(props);

    // console.log(decodeURI(props.match.params.word))

		// console.log(props)
		this.state = {
			word: decodeURI(props.match.params.word),
			history: props.location.state === undefined ? [] : props.location.state.history,
			from: props.location.state === undefined ? '' : props.location.state.from,
			// prevCategory: props.location.state === undefined ? 'all' : ('currentCategory' in props.location.state ? props.location.state.currentCategory:'all'),
			// parseIndex:0,

			// children:[],
    	// lexicon:'',
    	// pos:'',
    	// varsp:[],
    	// gloss:[],
    	soundfile:'',
    	semantic_domain:[],
    	dialect:[],
    	// reversal:[],
    	// examples:[],
    	// Possessed:'',
    	// PossTlingit:'',
    	// possValue:'311',
    	// Verb_Root:'',
    	// LeerEdwards_Theme:[],
    	// NaishStory_Theme:'',
    	// Conjugation_Prefix:'',
    	// Motion_Verbtype:'',
    	// Valence:'',
    	// Pronoun:'',
    	// notes1:[],
    	// notes2:[],
    	// verb_paradigms:[],
    	// verb_paradigms_roots:[],
    	// verb_paradigms_processed:{},
    	// noun_paradigms:[],
    	// adverb_paradigms:[],
			// siblings:[],
			// homonyms:[],
			// properties:[],

    	// loaded:false,

			// moodPOS:[],
			// POSCandidateList:[],
			// sortValue:0,

			// boldedsubject: true,
			// displaypos: true,
		}
	    // this.getWord = this.getWord.bind(this);
	    // this.getWord(decodeURI(props.match.params.word));
	    scroll.scrollTo(0);
	}

	// componentDidMount(){

	// }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.word !== this.props.match.params.word) {
    	// this.initializeWord()
    	scroll.scrollTo(0);
    }
  }


  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    this.setState({ 
			from: nextProps.location.pathname,
			// fullDefinition: nextProps.fullDefinition,
		})
	}


	processStyledText = (sentence) => {
		if (sentence !== undefined) {
			sentence = sentence.replace("⟨","").replace("⟩","").replace("«","").replace("»","")
			let matches = sentence.match(/⎡.*?⎤/g)
			let matches1 = sentence.match(/{.*?}/g)
			let matches2 = sentence.match(/_.*?_/g)
			if (matches !== null || matches1 !== null || matches2 !== null) {
				if (matches !== null) {
					matches.map((m) => sentence = sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>'))						
				}
				if (matches1 !== null) {
					matches1.map((m) => sentence = sentence.replace(m,m.slice(1,-1)))						
				}
				if (matches2 !== null) {
					matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))						
				}
				return <span dangerouslySetInnerHTML={{__html: sentence}} />		
			} else {
				return <span>{sentence}</span>
			}
		}
	}

    processStyledTextLink = (sentence) => {
      sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
      }

    }


  convertrjatuk = (phrase) => {
		var text = phrase.toLowerCase();
		text = text.replace("ā","A")
		text = text.replace("b","B")
		text = text.replace("c","C")
		text = text.replace("d","D")
		text = text.replace("e","E")
		text = text.replace("f","F")
		// text = text.replace("g","g")
		text = text.replace("q̄","H")
		text = text.replace("ō","I")
		text = text.replace("j","J")
		// text = text.replace("a","a")
		text = text.replace("ġ","b")
		text = text.replace("t̄","c")
		text = text.replace("p̄","d")
		text = text.replace("ł","e")
		text = text.replace("ŋ","f")
		// text = text.replace("g","g")
		// text = text.replace("h","h")
		// text = text.replace("i","i")
		text = text.replace("ḷ","j")
		// text = text.replace("k","k")
		// text = text.replace("l","l")
		// text = text.replace("m","m")
		// text = text.replace("n","n")
		text = text.replace("ł̣","o")
		// text = text.replace("p","p")
		// text = text.replace("q","q")
		// text = text.replace("r","r")
		// text = text.replace("s","s")
		// text = text.replace("t","t")
		// text = text.replace("u","u")
		// text = text.replace("v","v")
		// text = text.replace("w","w")
		// text = text.replace("x","x")
		return text
  }


  repeatAudio(id, inu, event, data) {
  	// console.log(audio)
    if (!this.state.playingAudio) {

      let sound = new Audio(API_URL + "kingikaudiolibrary?inu=" + inu + "&speakerID=" + id);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }


	render() {
		console.log(this.state)
    let currentEntry = this.props.siuTable[this.state.word]
    console.log(currentEntry)
		return (
			<div className="app" style={{fontFamily:customFontFam}}>


      <Grid textAlign='center'>
      <Grid.Row style={{paddingBottom:0}}>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
						<Link to={{pathname: "/search", state: { history:this.state.history }}} >
	          	<Button basic style={{paddingLeft:'10px',paddingRight:'15px',marginLeft:'3px'}} icon='left chevron' content='Back to Table' />
	          </Link>
 					<Button basic style={{float:'right',paddingLeft:'13px',paddingRight:'15px'}} icon='linkify' onClick={() => {navigator.clipboard.writeText(WEB_URL+'?p=search/'+currentEntry['id']); this.setState({copyClicked:true})}} content={this.state.copyClicked ? 'Copied!' : 'Share Link'} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
      <Grid.Column style={{ maxWidth: 860, padding: 10 }} textAlign='left'>

					<div style={{fontSize:'23px',marginTop:'10px',fontFamily:customFontFam}}>
						<div>
          		<div style={{display:'flex',paddingBottom:'7px'}}> 
              <span style={{fontWeight:'500',lineHeight:'30px'}}>
              {this.processStyledTextLink(currentEntry['k']+(false && currentEntry['type'] == 'v' ? '~' : ''))}
              	{typeof this.state.soundfile !== "undefined" && this.state.soundfile.length !== 0 ?
									<Icon circular onClick={()=>this.repeatAudio(this.state.soundfile)} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
									:
                  ('k' in currentEntry['audio'] ?
                    Object.keys(currentEntry['audio']['k']).map((id)=>{
                      return <Icon circular onClick={()=>this.repeatAudio(currentEntry['audio']['k'][id],currentEntry.k)} style={{marginLeft:'14px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
                    })                                  
                    :
                    null
                  )
              	}
              </span>


                <span style={{'marginLeft':'12px',marginTop:'3px'}}>
	              {this.state.dialect.length !== 0 ?
	              	(this.state.dialect.map((d)=>
		                <span style={{marginRight:'5px'}}>
		                  <TagColors tags={d} width={-1} />
		                </span>
		                )
	              	)
	                :
	                ''
	              }   
	              {false && currentEntry['type'] !== '' ?
	                <span style={{marginRight:'5px'}}>
	                  <TagColors tags={currentEntry['type']} width={-1} />
	                </span>
	                :
	                ''
	              }       
	              </span>      
              </div>
            </div>
					</div>

					<div style={{fontSize:'18px',marginTop:'5px',color:'#000000cc'}}>
						<div style={{marginBottom:'8px',lineHeight:'22px'}}>
							<span style={{fontFamily:'aamay24'}}>{this.convertrjatuk(currentEntry['k'])}</span>

              <span style={{'marginLeft':'12px'}}>
	                <span style={{marginRight:'5px'}}>
	                  <TagColors tags={'kin'} width={-1} />
	                </span>    
              </span>
              {currentEntry['sType'] == '1' ?
	              <span>
		                <span style={{marginRight:'5px'}}>
		                  <TagColors tags={'1'} width={-1} />
		                </span>    
	              </span>
	              :
	              null
	            }
              {currentEntry['sType'] == '2' ?
	              <span>
		                <span style={{marginRight:'5px'}}>
		                  <TagColors tags={'2'} width={-1} />
		                </span>    
	              </span>
	              :
	              null
	            }
              {currentEntry['sType'] == '3' ?
	              <span>
		                <span style={{marginRight:'5px'}}>
		                  <TagColors tags={'3'} width={-1} />
		                </span>    
	              </span>
	              :
	              null
	            }
              <span>
	                <span style={{marginRight:'5px'}}>
	                  <TagColors tags={'rjatuk'} width={-1} />
	                </span>    
              </span>

						</div>
					</div>

					<div style={{border:'1px solid #E3E3E3',marginTop:'14px'}}>


					{'e' in currentEntry && currentEntry['e'].length != 0 ?
					<div>
						<div className='hierarchymain'>
						<span className='span1'></span>
						<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Definition</span>
						</div>

						<div style={{marginTop:'17px',marginBottom:'18px'}}>
							<div style={{display:'flex',alignItems:'center',margin:'13px 0px',marginBottom:'10px'}}>
							<span style={{marginLeft:'10px',color:'#777777',fontSize:'20px','fontWeight':'300'}}>{'○'}</span>
							<span style={{marginLeft:'20px',color:'#000000',fontSize:'20px',lineHeight:'24px'}}>
							{this.processStyledText(currentEntry['e'])}
							</span>
							</div>

							</div>
						</div>
						:
						null
					}

					{'qaw' in currentEntry && currentEntry['qaw'].length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Dialects</span>
							</div>
							{['qaw','qik','utq','qig'].map((f)=>
								currentEntry[f].length !== 0 ?
								<div style={{marginTop:'18px',marginBottom:'18px'}} className='extrainformation'>
									{this.processStyledText(currentEntry[f])}
	                <span style={{'marginLeft':'12px'}}>
	                  <TagColors tags={f} width={-1} />
	                </span>    
								</div>
								:
								null
							)
							}
						</div>
						:
						null
					}



					{'zoom' in currentEntry && currentEntry['zoom'].length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Zoom Sessions</span>
							</div>
							<div style={{marginTop:'18px',marginBottom:'18px'}}>
								<span className='extrainformation'>This siu is discussed in the following videos:</span>
								<div style={{marginTop:'10px'}}>
								<Link><span className='extrainformation'  style={{borderBottom:'1px solid #306190',paddingBottom:'1px',color:'#306190'}}>{"Inupiaraaqta! Session 10/20/2022 15min 4sec"}</span></Link>
								</div>
								<div style={{marginTop:'10px'}}>
								<Link><span className='extrainformation'  style={{borderBottom:'1px solid #306190',paddingBottom:'1px',color:'#306190'}}>{"Inupiaraaqta! Session 10/13/2022 22min 14sec"}</span></Link>
								</div>

							</div>
						</div>
						:
						null
					}

					{'notes' in currentEntry && currentEntry['notes'].length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Notes</span>
							</div>
							{currentEntry['notes'].split('\n').map((d) => 
								<div style={{marginTop:'18px',marginBottom:'18px'}} className='extrainformation'>{this.processStyledText(d)}</div>
							)}
						</div>
						:
						null
					}

					{'docs' in currentEntry && currentEntry['docs'].length !== 0  ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Supplement</span>
							</div>
							<div style={{textAlign:'center'}}>
								<iframe 
									style={{border:'none'}}
									src={currentEntry['docs'][1]}
							      width="100%"
							      height="600"					/>
							</div>
							<div style={{textAlign:'center',paddingBottom:'20px',color:'#777777',fontSize:'16px'}}>{'This supplement can be edited '}<a href={currentEntry['docs'][0]} target="_blank">here</a>{"."}</div>

						</div>
						:
						null
					}

				</div>

					<div style={{paddingTop:'10px',paddingBottom:'30px',paddingLeft:'8px'}}>
			    <Link to={{pathname: '/report'}}>
						<Icon style={{color:'#a9a9a9',}} name='exclamation circle' />
						<span style={{fontSize:'14px',color:'#9d9d9d',fontWeight:'400',lineHeight:'23px'}}>Report an Issue</span>
          </Link>
					</div>


				</Grid.Column>
				</Grid.Row>
				</Grid>
			</div>
		);
	}
}
export default Entry;